import axiosInstance from "./axiosConfig";

// Function to fetch all property data and related agents
export const fetchPropertyData = async () => {
  try {
    const [propertiesResponse, agents] = await Promise.all([
      axiosInstance.get("/api/getproperties"),
      fetchAgentsData(),
    ]);

    const properties = propertiesResponse.data?.properties || [];

    if (!Array.isArray(properties)) {
      // console.error(
      //   "Unexpected data format. Expected an array but got:",
      //   properties
      // );
      return [];
    }

    const agentsById = new Map(
      (Array.isArray(agents) ? agents : []).map((agent) => [
        agent.agentId,
        agent,
      ])
    );

    return properties.map((property) => ({
      ...property,
      agent: agentsById.get(property.uid) || null,
    }));
  } catch (error) {
    // console.error("Error fetching property info:", error);
    return [];
  }
};

// Generic fetcher functions
export const fetchAgentsData = async () => {
  try {
    const response = await axiosInstance.get("/api/agents");
    return response.data;
  } catch (error) {
    // console.error("Error fetching agents data:", error);
    return [];
  }
};

export const fetchUserImage = async () => {
  try {
    const response = await axiosInstance.get("/api/user-image");
    return response.data;
  } catch (error) {
    // console.error("Error fetching user image:", error);
    return null;
  }
};

export const fetchUserDetails = async () => {
  try {
    const response = await axiosInstance.get("/api/user-details");
    return response.data;
  } catch (error) {
    // console.error("Error fetching user details:", error);
    return null;
  }
};

export const fetchContactInfo = async () => {
  try {
    const response = await axiosInstance.get("/api/contact");
    return response.data;
  } catch (error) {
    // console.error("Error fetching contact info:", error);
    return [];
  }
};

export const fetchServicesData = async () => {
  try {
    const response = await axiosInstance.get("/api/services");
    return response.data;
  } catch (error) {
    // console.error("Error fetching services data:", error);
    return [];
  }
};

export const fetchClients = async () => {
  try {
    const response = await axiosInstance.get("/api/clients");
    return response.data;
  } catch (error) {
    // console.error("Error fetching clients:", error);
    return [];
  }
};

export const fetchNewsData = async () => {
  try {
    const response = await axiosInstance.get("/api/blogs");
    return response.data;
  } catch (error) {
    // console.error("Error fetching news:", error);
    return [];
  }
};

export const fetchTestimonialsData = async () => {
  try {
    const response = await axiosInstance.get("/api/testimonials");
    return response.data;
  } catch (error) {
    // console.error("Error fetching testimonials:", error);
    return [];
  }
};

export const fetchFaqs = async () => {
  try {
    const response = await axiosInstance.get("/api/faqs");
    return response.data;
  } catch (error) {
    // console.error("Error fetching FAQs:", error);
    return [];
  }
};

export const fetchStats = async () => {
  try {
    const response = await axiosInstance.get("/api/stats");
    return response.data;
  } catch (error) {
    // console.error("Error fetching statistics:", error);
    return [];
  }
};
